import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet'
import { Briefcase, PlusCircle, Edit, XCircle, ChevronLeft, ChevronRight } from 'react-feather'
import { Link, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import ReactPaginate from 'react-paginate'

// variables
import { SITENAME } from '../../configuration.js';

// components
import PageHead from '../../components/PageHead';
import Loading from '../../components/Loading';
import Table from '../../components/Table';
import TextSearchField from '../../components/TextSearchField';

// controllers
import { _apiGETmulti, _apiDELETE, _apiPUT } from '../../controllers/Api';


export default function Clients(props){

  const location = useLocation()

  const fields = {
    limit: 15,
    offset: 0,
    orderBy: 'dateCreated|desc',
    search: ''
  }

  const [ reload, setReload ] = React.useState(1);

  const [ loading, setLoading ] = React.useState(true);
  const [ request, setRequest ] = React.useState(location.state ? location.state.request : fields)
  const [ requestAction, setRequestAction ] = React.useState(location.state ? location.state.request : fields)
  const [ total, setTotal ] = React.useState(0)
  const [ data, setData ] = React.useState([])


  //
  //
  const _paginateAction = (e) => {
    const offset = e.selected === 0 ? 0 : (e.selected*fields.limit)
    _updateField('offset',offset)
  }



  //
  //
  const _updateField = (field, data) => {
    setRequest({...request, [field]:data});
  }


  //
  //
  const _delete = async (id) => {

    if (!window.confirm(`Are you sure you want to delete?`)){
      return;
    }else{
      const del = await _apiDELETE('/clients/'+id);
      if(del.statusCode !== 200){
        toast.error(del.message);
      }else{
        toast.success(del.message);
        setReload(reload+1)
      }
    }
  }


  //
  //
  const _changeStatus = async (index, status) => {
    const update = await _apiPUT('/clients/status/'+data[index]._id, {status: status});
    if(update.statusCode !== 200){
      toast.error(update.response.data.message);
    }else{
      toast.success(update.message);
      setReload(reload+1)
    }
  }


  //
  //
  React.useEffect(() => {
    const timeoutId = setTimeout(() => request !== '' ? setRequestAction(request) : null, 500 );
    return () => clearTimeout(timeoutId);
  }, [request]);


  //
  //
  React.useEffect(()=>{

    setLoading(true)

    const getData = async () =>{
      const res = await _apiGETmulti('/clients/query', requestAction)
      if(!res){

      }else{
        setTotal(res.total)
        setData(res.data)
      }
      setLoading(false)
    }
    getData()

    return (() => [getData])
  },[requestAction, reload])


  //
  //
  const _options = (data, index) => {

    return (
      <div className="d-flex justify-content-end align-items-center">
        <div className="switch small">
          <input
            type="checkbox"
            name="status"
            value="1"
            checked={data.status}
            onChange={(e)=>_changeStatus(index, !data.status)}
            className={`form-control`}
          />
          <div><i></i></div>
        </div>
        <Link to={{pathname:'/clients/'+data._id, state:{request:request, pathname:location.pathname}}} className="iconButton"><Edit size={20}/></Link>
        <button className="iconButton" onClick={()=>_delete(data._id)}><XCircle size={20}/></button>
      </div>
    )

  }


  //
  //
  const _name = (data) => {
    return data.firstName+' '+data.lastName
  }


  //
  //
  const _status = (value) => {
    return <span className={!value.status ? 'status error' : 'status success'}>{!value.status ? 'inactive' : 'active'}</span>
  }


  //
  //
  const _totals = (value) => {
    return value.totals.month+' | '+value.totals.year+' | '+value.totals.all
  }



  //
  //
  return (
    <Fragment>
      <Helmet>
        <title>Clients | { SITENAME }</title>
      </Helmet>

      <PageHead
        title="Clients"
        icon={<Briefcase size={52}/>}
      >
        <TextSearchField
          type="text"
          name="search"
          value={request.search}
          onChange={(e)=>_updateField('search',e)}
          placeholder="search..."
        />
        <Link to={{pathname:'/clients/new', state:{request:request, pathname:location.pathname}}} className="button accent ml-1"><PlusCircle/>Add new</Link>
      </PageHead>

      <div className="relative w-100">
        {total===0 ?
          <div className="text-center py-4">{loading ? 'loading...' : 'No data vailable.'}</div>
        :
          <>
          <Table
            action={_updateField}
            perPage={request.limit}
            sortBy={request.orderBy}
            head={
              [
                {name:'Company', width:'auto', sortable:true, key:'company'},
                {name:'Owner', width:'30%', sortable:false, key:'Owner', type:'function', func:_name},
                {name:'Status', width:'10%', sortable:true, key:'status', func:_status, type:'function'},
                {name:'(Month/Year/All)', width:'20%', sortable:false, key:'totals', func:_totals, type:'function'},
                {name:'Created on', width:'15%', sortable:true, key:'dateCreated', type:'date'},
                {name:'Options', width:'15%', sortable:false, key:'_', type:'function', func:_options}
              ]
            }
            body={data}
            total={total}
          />
          <ReactPaginate
            previousLabel={<ChevronLeft/>}
            nextLabel={<ChevronRight/>}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={Math.ceil(total/fields.limit)}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={_paginateAction}
            containerClassName={'pagination'}
            activeClassName={'active'}
          />
          </>
        }
        <Loading status={loading}/>
      </div>

    </Fragment>
  );

}
